import { render } from "./mega-menu-list.vue?vue&type=template&id=52a96f67"
import script from "./mega-menu-list.vue?vue&type=script&lang=js"
export * from "./mega-menu-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__